// import { useGetEventDetail } from '@wbk/contentful/api';
import { useTranslation } from 'react-i18next';
// import { useParams } from 'react-router-dom';
import Seo from '@/components/headers/seo';
// import Error404 from '@/components/error/404';
// import FullpageAnimatedLogo from '@/components/ui/Loading/FullpageAnimatedLogo';

const HamzaCairokeeMarwanConcertPage = () => {
  // const { lang } = useParams<{ lang: Language }>();
  const { t } = useTranslation('common');

  //   const { data: eventData, isLoading: eventLoading } = useGetEventDetail({
  //     lang,
  //     limit: 1,
  //     where: { slug: 'hamza-cairokee-marwan-concert-rs25-tickets' },
  //   });

  //   if (eventLoading) {
  //     return <FullpageAnimatedLogo />;
  //   }

  //   const event = eventData?.data?.[0];

  //   if (!event) {
  //     return <Error404 />;
  //   }

  const title = t('hamza_cairokee_marwan_concert.title');
  const subtitle = t('hamza_cairokee_marwan_concert.subtitle');

  return (
    <>
      <Seo title={title} description={subtitle} image='/images/hamza-cairokee/1280x426.jpg' />

      <div className='min-h-screen bg-gradient-to-b py-8 pt-44'>
        <div className='container px-8 lg:px-12 2xl:px-20'>
          <div className='mb-8 text-center'>
            <h1 className='text-2xl font-bold text-white md:text-3xl'>{title}</h1>
          </div>

          {/* Hero Image */}
          <div className='mb-8 overflow-hidden rounded-lg'>
            <picture>
              <source media='(max-width: 600px)' srcSet='/images/hamza-cairokee/1920x1280.jpg' />
              <img
                src='/images/hamza-cairokee/1280x426.jpg'
                alt={title}
                className='w-full object-cover'
              />
            </picture>
          </div>

          {/* Subtitle/Description */}

          <div className='mb-8 text-center'>
            <p className='text-lg text-white'>{subtitle}</p>
          </div>

          {/* Social Links */}
          <div className='flex items-center justify-center gap-4 sm:gap-6'>
            <a
              href='https://x.com/benchmark_ksa?s=21&t=SjvJmd-9gpLV44C5kVoyBg'
              className='flex h-10 w-10 items-center justify-center rounded-full sm:h-12 sm:w-12 md:h-12 md:w-12 lg:h-16 lg:w-16'
              aria-label='Twitter'
              rel='noreferrer'
              target='_blank'
            >
              <img
                src='/images/hamza-cairokee/logo-white.png'
                alt='x'
                className='h-5 w-5 sm:h-6 sm:w-6 md:h-8 md:w-8'
              />
            </a>
            <a
              href='https://youtube.com/@benchmarkksa?si=ys4ELemL1tje-b67'
              className='flex h-10 w-10 items-center justify-center rounded-full bg-red-500 hover:bg-red-600 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16'
              aria-label='YouTube'
              rel='noreferrer'
              target='_blank'
            >
              <img
                src='/images/hamza-cairokee/youtube.svg'
                alt='YouTube'
                className='h-4 w-4 sm:h-6 sm:w-6 md:h-8 md:w-8'
              />
            </a>
            <a
              href='https://facebook.com/benchmarkksa/'
              className='flex h-10 w-10 items-center justify-center rounded-full bg-blue-600 hover:bg-blue-700 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16'
              aria-label='Facebook'
              rel='noreferrer'
              target='_blank'
            >
              <img
                src='/images/hamza-cairokee/facebook.svg'
                alt='Facebook'
                className='h-4 w-4 sm:h-6 sm:w-6 md:h-8 md:w-8'
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default HamzaCairokeeMarwanConcertPage;
